export default {
  namespaced: true,
  state: {
    isWsAuthenticated: false,
  },
  mutations: {
    setAuthenticated(state, value) {
      state.isWsAuthenticated = value;
    },
  },
};
